import { createImmutableSelector } from 'util/reselectUtils';

export const getServicesFromState = (state) => state.getIn(['entities', 'service', 'services']);

// Returns all services from the state
export const getServices = createImmutableSelector(
  [getServicesFromState, (state, props) => props?.search],
  (services, search) => {
    if (!search) {
      return services;
    }

    return services.filter((service) => {
      const fullHeader = service.get('name') + service.get('description');
      return fullHeader?.toLowerCase()?.indexOf(search.toLowerCase()) !== -1;
    });
  },
);

export const getServiceById = (state, { serviceId }) => state.getIn(['entities', 'service', 'services', serviceId]);
